import { Typography, Button, Stack, TextField } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import HelpModal from "components/DataDisplay/HelpModal/HelpModal";
import { useState, useEffect } from "react";
import { useConsigazApi } from "hooks/useConsigazApi";
import { maskCpf, validateCpfCnpj } from "utils/Masks/Masks";

export default function ForgotMyPassword({
  segment,
  cpfCnpj,
  email,
  cpfAccess,
  requestCpf,
}) {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [openHelpModal, setOpenHelpModal] = useState(false);
  const [cpfField, setCpfField] = useState("");
  const [cpfRequested, setCpfRequested] = useState("");
  const [isCpfValid, setIsCpfValid] = useState(false);
  const [validEmail, setValidEmail] = useState(email)

  const api = useConsigazApi();


  const sendResetEmail = async () => {
    setSecondsLeft(30);
    setIsDisabled(true);
    try {
      await api.sendLinkResetPassword({
        tipo: segment,
        cpfCnpj: requestCpf
          ? cpfRequested
          : segment === "CONTASIM"
            ? cpfCnpj
            : cpfAccess,
      });
    } catch (error) {
      console.error("Error sending reset email:", error);
    }
  };

  useEffect(() => {
    let timer;
    if (secondsLeft > 0) {
      timer = setTimeout(() => {
        setSecondsLeft(secondsLeft - 1);
      }, 1000);
    } else {
      setIsDisabled(false);
    }
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  useEffect(() => {
    if (!validEmail && segment === "INDUSTRIAL" && cpfRequested) {
      const fetchEmail = async () => {
        try {
          const cleanCpf = cpfRequested.replace(/\D/g, "");
          const cleanCnpj = cpfCnpj.replace(/\D/g, "");
          const response = await api.consultCpfCnpj(cleanCpf, segment, cleanCnpj);
          const userData = response.RetornoUsuario?.[0];
          setValidEmail(userData?.email);
        } catch (error) {
          console.error("Error fetching industrial account email:", error);
        }
      };
      fetchEmail();
    }
  }, [cpfRequested]);

  if (requestCpf && !cpfRequested) {
    return (
      <Stack gap={"70px"}>
        <Stack textAlign="justify">
          <Typography
            color="#FFFFFF"
            fontWeight={700}
            fontSize="30px"
            mt="30px"
          >
            Redefinição de senha
          </Typography>
          <Typography color="#FFFFFF" fontSize="15px" mt="10px">
            Para recuperar o acesso da conta, será enviado email com instruções
            de redefinição de senha para o endereço cadastrado abaixo. Por
            favor, acesse sua caixa de entrada e clique no link.
          </Typography>
          <Typography color="#FFFFFF" fontSize="15px" mt="15px">
            Não encontrou o email para recuperação? Lembre-se de checar sua
            caixa de spam ou lixo eletrônico. Ainda precisa de ajuda? acesse
            nossos canais de contato abaixo.
          </Typography>
        </Stack>

        <TextField
          variant="standard"
          color="secondary"
          value={cpfField}
          fullWidth
          onChange={(e) => {
            const maskedCpf = maskCpf(e.target.value);
            setIsCpfValid(validateCpfCnpj(maskedCpf));
            setCpfField(maskedCpf);
          }}
          placeholder="CPF"
          sx={{
            "& input": {
              color: "gray",
            },
          }}
        />

        <Stack alignItems={"center"}>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              height: "55px",
              color: "#fff",
              borderRadius: "36px",
              width: "100%",
              mt: 2,
            }}
            onClick={() => setCpfRequested(cpfField)}
            disabled={!isCpfValid}
          >
            Avançar
          </Button>
          <Typography
            color="#2CABF9"
            fontWeight={600}
            fontSize={"15px"}
            mt={"30px"}
            mb={8}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => setOpenHelpModal(true)}
          >
            Preciso de ajuda
          </Typography>
        </Stack>
        <HelpModal
          open={openHelpModal}
          onClose={() => setOpenHelpModal(false)}
          fullModal={true}
        />
      </Stack>
    );
  }

  return (
    <Stack gap={"70px"}>
      <Stack textAlign="justify">
        <Typography color="#FFFFFF" fontWeight={700} fontSize="30px" mt="30px">
          Redefinição de senha
        </Typography>
        <Typography color="#FFFFFF" fontSize="15px" mt="10px">
          Para recuperar o acesso da conta, será enviado email com instruções de
          redefinição de senha para o endereço cadastrado abaixo. Por favor,
          acesse sua caixa de entrada e clique no link.
        </Typography>
        <Typography color="#FFFFFF" fontSize="15px" mt="15px">
          Não encontrou o email para recuperação? Lembre-se de checar sua caixa
          de spam ou lixo eletrônico. Ainda precisa de ajuda? Acesse nossos
          canais de contato abaixo.
        </Typography>
      </Stack>

      <Stack
        backgroundColor="#FFFFFF0D"
        p="24px"
        borderRadius="8px"
        mt="20px"
        direction="row"
        alignItems="center"
      >
        <EmailIcon sx={{ fontSize: "35px", mr: "24px" }} />
        <Stack textAlign={"justify"}>
          <Typography color="#939393" fontSize="14px">
            Email cadastrado:
          </Typography>
          <Typography color="#FFFFFF" fontSize="20px" fontWeight={600}>
            {(validEmail || "").replace(/(.{2}).+@/, "$1****@")}
          </Typography>
        </Stack>
      </Stack>

      <Stack alignItems={"center"}>
        <Button
          variant="contained"
          color="secondary"
          sx={{
            height: "55px",
            color: "#fff",
            borderRadius: "36px",
            width: "100%",
            mt: 2,
          }}
          onClick={sendResetEmail}
          disabled={isDisabled}
        >
          {secondsLeft > 0 ? `Reenviar em ${secondsLeft}s` : "Redefinir senha"}
        </Button>
        <Typography
          color="#2CABF9"
          fontWeight={600}
          fontSize={"15px"}
          mt={"30px"}
          mb={8}
          sx={{
            cursor: "pointer",
          }}
          onClick={() => setOpenHelpModal(true)}
        >
          Preciso de ajuda
        </Typography>
      </Stack>
      <HelpModal
        open={openHelpModal}
        onClose={() => setOpenHelpModal(false)}
        fullModal={true}
      />
    </Stack>
  );
}
